/**
 * @generated SignedSource<<62e1ddf7a31d6c2cd92e883878747249>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type PostgreSQLIntegrationDeleteMutation$variables = {
  input: DeleteIntegrationInput;
};
export type PostgreSQLIntegrationDeleteMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PostgreSQLIntegrationDeleteMutation = {
  response: PostgreSQLIntegrationDeleteMutation$data;
  variables: PostgreSQLIntegrationDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostgreSQLIntegrationDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostgreSQLIntegrationDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ecf65c3d460d07fa0251e63c9a62ba3e",
    "id": null,
    "metadata": {},
    "name": "PostgreSQLIntegrationDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PostgreSQLIntegrationDeleteMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "7307a8a6b94ce1c4dff037ed0609c70b";

export default node;
